export class changePasswordDto{
    currentPassword:string;
    newPassword:string;
    confirmNewPassword: string;
}